/* @flow */

import * as React from 'react'
import styled from 'styled-components'

import { resolveSingleFont } from '../../../../../infrastructure/components/CustomFont/helpers'
import { useCachedCustomFonts } from '../../../../entities/hooks'
import { addPxToInput, addSuffixToInput } from '../../../../shared'
import { WidgetContainer } from '../shared'

const WebshopAnnouncementBar = ({ gridItem, isMobile }) => {
  const [customFonts, isFetchingCustomFonts, isInitializedCustomFonts] =
    useCachedCustomFonts()

  const [font, setFont] = React.useState("'proxima-nova', sans-serif")

  React.useEffect(() => {
    if (gridItem.data.font && isInitializedCustomFonts) {
      const customFont = customFonts.find(
        font => font.id === gridItem.data.font
      )

      resolveSingleFont(customFont).then(font =>
        setFont(`'${font.family}', ${font.category}`)
      )
    } else {
      setFont("'proxima-nova', sans-serif")
    }
  }, [gridItem.data.font, customFonts, isInitializedCustomFonts, setFont])

  let ContainerComponent =
    gridItem.data.style === 'ticker' ? TickerContainer : StaticContainer

  let innerComponents = <span>{gridItem.data.announcement}</span>

  if (gridItem.data.style === 'ticker') {
    innerComponents = (
      <Ticker gridItem={gridItem}>{gridItem.data.announcement}</Ticker>
    )
  }

  return (
    <ContainerComponent gridItem={gridItem} font={font}>
      {innerComponents}
    </ContainerComponent>
  )
}

export default WebshopAnnouncementBar

const BaseContainer = styled(WidgetContainer)`
  background-color: ${({ gridItem }) => gridItem.data.background_color};
  color: ${({ gridItem }) => gridItem.data.font_color};
  font-family: ${({ font }) => font};
  font-size: ${({ gridItem }) => addPxToInput(gridItem.data.font_size)};
  height: ${({ gridItem }) => addPxToInput(gridItem.data.height)};
  line-height: ${({ gridItem }) => addPxToInput(gridItem.data.height)};
  position: relative;
  width: 100%;
`

const TickerContainer = styled(BaseContainer)`
  overflow: hidden;
`

const StaticContainer = styled(BaseContainer)`
  text-align: center;
`

const Ticker = styled.span`
  white-space: nowrap;
  display: block;
  position: relative;
  animation: ticker
    ${({ gridItem }) => addSuffixToInput(gridItem.data.ticker_speed || 10, 's')}
    linear infinite;

  @keyframes ticker {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`
